import { TableColumn } from 'react-data-table-component';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { useManageUserModalStore } from './Modal/UserModal/useMangeUserModalStore';
import { useDeleteUserModalStore } from './Modal/DeleteUserModal/useDeleteUserModalStore';
import { RoleTransformNames } from './Modal/UserModal/RoleOptions';

import { UsersPageDataRow } from 'api/users/types';
import { Breakpoints } from 'hooks/Screen/useScreenSize';

export const useGetUsersPageColumns = (table_name: string): TableColumn<UsersPageDataRow>[] => {
  const { onManageUserModalOpen } = useManageUserModalStore();
  const { onDeleteUserModalOpen } = useDeleteUserModalStore();

  const columns = [
    {
      name: 'User',
      selector: (row: UsersPageDataRow) => row.last_name,
      sortable: true,
      sortField: 'last_name',
      cell: (row: UsersPageDataRow) => (
        <div className="d-flex align-items-center">
          <div className="avatar-sm flex-shrink-0 me-3 d-none d-md-block">
            <img
              src={row.avatar}
              alt=""
              className="rounded-circle img-thumbnail"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            />
          </div>
          <div className="fw-bold" style={{ color: '#495057' }}>
            {row.first_name} {row.last_name}
          </div>
        </div>
      ),
      style: {
        justifyContent: 'start',
      },
    },
    {
      name: 'Role',
      selector: (row: UsersPageDataRow) => RoleTransformNames[row.role as keyof typeof RoleTransformNames] || row.role,
      sortable: true,
      sortField: 'role',
      hide: Breakpoints.Desktop,
    },
    {
      name: 'Email',
      selector: (row: UsersPageDataRow) => row.email,
      sortable: true,
      sortField: 'email',
      hide: Breakpoints.Tablet,
    },
    {
      name: 'Phone',
      selector: (row: UsersPageDataRow) => row.phone_number || 'No Phone Number',
      hide: Breakpoints.Desktop,
    },
    {
      name: 'Actions',
      selector: (row: UsersPageDataRow) => row.id || '',
      width: '100px',
      style: {
        justifyContent: 'center',
        padding: '0',
      },
      cell: (row: UsersPageDataRow) => (
        <span>
          <div className="dropdown">
            <button
              className="btn btn-ghost-purple btn-sm dropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ padding: '4px 8px', margin: '0' }}
            >
              <i className="ri-more-fill" />
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li className="px-3">
                <button
                  className="dropdown-item edit-list d-flex align-items-center  justify-content-start border-bottom  card-animate"
                  onClick={() => onManageUserModalOpen(true, row)}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" /> Edit
                </button>
              </li>
              <li className="px-3">
                <button
                  className="dropdown-item edit-list d-flex align-items-center justify-content-start border-bottom card-animate"
                  onClick={() => onDeleteUserModalOpen(row)}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted" /> Remove
                </button>
              </li>
            </ul>
          </div>
        </span>
      ),
    },
  ];

  if (table_name === 'client_users') {
    const companyNameColumn = {
      name: 'Client Company Name',
      selector: (row: UsersPageDataRow) => row.company_name || '',
      sortable: true,
      sortField: 'company_name',
      hide: Breakpoints.LargeDesktop,
    };

    columns.splice(1, 0, companyNameColumn);
  }

  return columns;
};

export default useGetUsersPageColumns;
